<template>
  <v-app>
    <NavBar v-if="showHeader" @onLoginClick="openAuth" />
    <AuthModal ref="authModal" />
    <router-view></router-view>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import AuthModal from '@/components/AuthModal.vue';

export default {
  name: 'App',
  components: { NavBar, AuthModal },
  data: () => ({
    showHeader: true
  }),
  methods: {
    openAuth() {
      this.$refs.authModal.open('login')
    }
  },
}
</script>

<style>
.swal2-shown {
  font-family: 'Poppins', sans-serif;
}
</style>
